import React from 'react';
import PropTypes from 'prop-types';
import {TextField} from "@mui/material";
import CurrencyRangeInput from "../../components/currency-range-input";
import SearchForm from "../../components/search-form";



interface ContactsSearchProps {
  isOpen?: boolean;
  onCancel: () => void;
  params?: any[];
  onSearch: (fields: any) => void;
}

class ContactsSearch extends React.Component<ContactsSearchProps> {
  static propTypes: any;
  static fieldTypes = [
    {
      label: 'Contact Name', id: 'contactName',
      variants: [{
        id: 'like',
        label: 'Like',
        editor: ({input}) => <TextField {...input} label="Name of contact"/>
        }
      ]
    }, {
      label: 'Sales Company', id: 'salesCompany',
      default: true,
      variants: [
        {
          default:true,
          id: 'like',
          label: 'Like',
          editor: ({input}) => <TextField {...input} label="Name of sales company"/>
        },
      ]
    }, {
      label: 'Accounts Company', id: 'accountsCompany',
      variants: [
        {
          id: 'like',
          label: 'Like',
          editor: ({input}) => <TextField {...input} label="Name of accounts company"/>
        }
      ]
    }, {
      label: 'Sage Customer Account Ref', id: 'accountsCode',
      variants: [
        {
          id: 'exact',
          label: 'Exact',
          editor: ({input}) => <TextField {...input} label="Account Ref"/>
        }
      ]
    }, {
      label: 'Accounts Address', id: 'accountsAddress',
      variants: [
        {
          id: 'like',
          label: 'Like',
          editor: ({input}) => <TextField {...input} label="Address of accounts company"/>
        }
      ]
    }, {
      label: 'Sales Address', id: 'salesAddress',
      variants: [
        {
          id: 'like',
          label: 'Like',
          editor: ({input}) => <TextField {...input} label="Address of sales company"/>
        }
      ]
    }, 
    /*{
    label: 'Sales Team',id:'salesTeamId',
      variants: [{
        id: 'in',
        multi:true,
        label: 'Lookup',
        clearOnChange:true,
        getValue: (val)=> { return val.id; },
        editor: ({input}) => <FormGroup  className="flex-expand" label="&nbsp;"><SalesTeamSelect multi={true} {...input} popup={true}/></FormGroup>
      }]
    }, {
      label: 'Sales Contact', id: 'user',
      variants: [
        {
          id: 'in',
          multi:true,
          label: 'Lookup',
          clearOnChange:true,
          getValue: (val)=> { return val.id; },
          editor: ({input}) => <FormGroup  className="flex-expand" label="&nbsp;"><UserSelect multi={true} {...input} popup={true}/></FormGroup>
        }
      ]
    },*/
     {
      label: 'Credit Limit', id: 'credit_limit',
      variants: [
        {
          id: 'range',
          label: 'Range',
          clearOnChange:true,
          editor: ({input}) => {
            return (<CurrencyRangeInput {...input} label="Between"/>);
          }
        }
      ]
    }
  ];
  render() {
    return <SearchForm onCancel={this.props.onCancel} onSearch={this.props.onSearch} isOpen={this.props.isOpen}
                       params={this.props.params}
                       fieldTypes={ContactsSearch.fieldTypes}
                       name="contacts"
                       label="Contacts "
    />
  }
}

ContactsSearch.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  params: PropTypes.array,
  onSearch: PropTypes.func.isRequired
};

export default ContactsSearch;
